module.exports = __webpack_public_path__ + "img/yellow_d.cf94e50c.svg";